module.exports = __webpack_public_path__ + "img/demo-west_covina.0ee995d0.png";